export const customerTypeDictionary = {  company: 'COMPANY',  endCustomer: 'END_CUSTOMER',}